import { render, staticRenderFns } from "./OrderTracking.vue?vue&type=template&id=37d0ef9e&scoped=true"
import script from "./OrderTracking.vue?vue&type=script&lang=js"
export * from "./OrderTracking.vue?vue&type=script&lang=js"
import style0 from "./OrderTracking.vue?vue&type=style&index=0&id=37d0ef9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d0ef9e",
  null
  
)

export default component.exports